import { useOutletContext } from "react-router-dom";
import UsersTable from "../../components/adminDashboard/ui/users/UsersTable.jsx";
import UserDetail from "../../components/adminDashboard/ui/users/UserDetail.jsx";
import UserOnboarding from "../../components/adminDashboard/ui/users/UserOnboarding.jsx";

export default function UserManagement() {
  const {
    usersData,
    userSearchQuery,
    setUserSearchQuery,
    isUserOnboarding,
    setIsUserOnboarding,
    selectedUserDetails,
    setSelectedUserDetails,
    userOnboardStep,
    setUserOnboardStep,
    handleFinishUserOnboarding,
    getUserList,
    companiesData,
    groups,
  } = useOutletContext();
  return (
    <>
      {!isUserOnboarding && selectedUserDetails && (
        <UserDetail user={selectedUserDetails} />
      )}
      {!isUserOnboarding && !selectedUserDetails && (
        <UsersTable
          users={usersData}
          searchQuery={userSearchQuery}
          setSearchQuery={setUserSearchQuery}
          onSelect={setSelectedUserDetails}
          setIsUserOnboarding={setIsUserOnboarding}
          onBack={() => {
            setSelectedUserDetails(null);
            getUserList();
          }}
        />
      )}
      {isUserOnboarding && (
        <UserOnboarding
          step={userOnboardStep}
          setStep={setUserOnboardStep}
          onFinish={handleFinishUserOnboarding}
          companies={companiesData}
          groups={groups}
          selectedUserDetails={selectedUserDetails}
        />
      )}
    </>
  );
}
